import { useEffect, useState } from 'react';
import { Switch } from '../../components/ui/switch';
export default function GameVisibilitySettings({ api }) {
  const [testAccounts, setTestAccounts] = useState([]);
  const [enabled, setEnabled] = useState(false), [ready, setReady] = useState(false), [saving, setSaving] = useState(false), [error, setError] = useState('');
  useEffect(() => {
    let active = true;
    api.get('/admin/games/salto/visibility').then(({ data }) => { if (active) { setEnabled(data.enabled); setTestAccounts(data.test_accounts || (data.test_account ? [data.test_account] : [])); setReady(true); } })
      .catch(() => { if (active) setError('No se pudo cargar la visibilidad del juego.'); });
    return () => { active = false; };
  }, [api]);
  const change = async value => {
    setSaving(true); setError('');
    try { const { data } = await api.put('/admin/games/salto/visibility', { enabled: value }); setEnabled(data.enabled); }
    catch { setError('No se pudo guardar el cambio.'); }
    finally { setSaving(false); }
  };
  return <div className="rounded-xl border p-4 mb-4 bg-slate-50 dark:bg-slate-800">
    <div className="flex justify-between items-center gap-4"><label htmlFor="game-enabled" className="font-semibold">Juego · Aorra Salto</label>
      <Switch id="game-enabled" aria-label="Activar juego para todos" checked={enabled} disabled={!ready || saving} onCheckedChange={change} /></div>
    <p className="text-xs text-slate-500 mt-2">{enabled ? 'Disponible para todas las cuentas.' : `Apagado para el público. ${testAccounts.length ? 'Cuentas de prueba autorizadas: ' + testAccounts.join(', ') + '.' : 'No hay cuentas de prueba autorizadas.'}`} Este interruptor guarda el cambio inmediatamente.</p>
    {error && <p role="alert" className="text-red-600 text-sm">{error}</p>}
  </div>;
}
